import { config } from "@/config";
export class OrdenVentaService {
    static async getAll() {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok)
            throw new Error("Error fetching OrdenVenta");
        return response.json();
    }
    static async getMonitorDespacho() {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta/monitor-despacho`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
        });
        if (!response.ok)
            throw new Error("Error fetching monitor-despacho");
        return response.json();
    }
    static async connectMonitorDespachoSse(signal, onData, onError) {
        try {
            const response = await fetch(`${config.API_URL}/api/OrdenVenta/sse-monitor-despacho`, {
                headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
                signal: signal
            });
            if (!response.body)
                throw new Error("No response body in SSE");
            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");
            let buffer = "";
            while (true) {
                const { value, done } = await reader.read();
                if (done)
                    break;
                buffer += decoder.decode(value, { stream: true });
                let boundary = buffer.indexOf('\n\n');
                while (boundary !== -1) {
                    const message = buffer.substring(0, boundary);
                    buffer = buffer.substring(boundary + 2);
                    if (message.startsWith('data: ')) {
                        try {
                            const parsed = JSON.parse(message.substring(6));
                            if (Array.isArray(parsed))
                                onData(parsed);
                        }
                        catch (e) { }
                    }
                    boundary = buffer.indexOf('\n\n');
                }
            }
        }
        catch (e) {
            if (e.name !== 'AbortError')
                onError(e);
        }
    }
    static async getBorradores() {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta/borradores`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
        });
        if (!response.ok)
            throw new Error("Error fetching borradores");
        return response.json();
    }
    static async getComandas() {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta/comandas`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
        });
        if (!response.ok)
            throw new Error("Error fetching comandas");
        return response.json();
    }
    static async getCaja() {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta/caja`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
        });
        if (!response.ok)
            throw new Error("Error fetching caja");
        return response.json();
    }
    static async getFacturadas() {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta/facturadas`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
        });
        if (!response.ok)
            throw new Error("Error fetching facturadas");
        return response.json();
    }
    static async getById(id) {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok)
            throw new Error("Error fetching OrdenVenta by id");
        return response.json();
    }
    static async getByClienteId(clienteId) {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta/cliente/${clienteId}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok)
            throw new Error("Error fetching OrdenVenta by cliente");
        return response.json();
    }
    static async create(data) {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!response.ok)
            throw new Error("Error creating OrdenVenta");
        return response.json();
    }
    static async cambiarEstado(id, nuevoEstado) {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta/${id}/estado`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(nuevoEstado),
        });
        if (!response.ok)
            throw new Error("Error changing status");
        return response.json();
    }
    static async anular(id) {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta/${id}/anular`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok)
            throw new Error("Error anulando OrdenVenta");
        return response.json();
    }
    static async facturar(id, metodoPago, detalles) {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta/${id}/facturar`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ metodoPago, detalles }),
        });
        if (!response.ok)
            throw new Error("Error facturando OrdenVenta");
        return response.json();
    }
    static async solicitarReingreso(id, detalles) {
        const response = await fetch(`${config.API_URL}/api/OrdenVenta/${id}/solicitar-reingreso`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(detalles),
        });
        if (!response.ok)
            throw new Error("Error solicitando reingreso");
        return response.json();
    }
}
